import WholesaleForm from '../../components/forms/WholesaleForm';

/**
 * Wholesale application page.
 *
 * A dedicated, shareable page for the wholesale application (previously a
 * modal). Renders WholesaleForm without an onSuccess handler so the form's
 * own success screen stays visible after submitting.
 */
function Wholesale() {
  return (
    <main>
      {/* PAGE HEAD */}
      <div className="page-head">
        <div className="page-head-inner">
          <p className="label">Wholesale Program</p>
          <h1>Apply for Wholesale</h1>
          <p>
            Tell us about your business and upload your resell certificate. Our
            team reviews applications and responds within 24–48 hours.
          </p>
        </div>
      </div>

      <div className="products-wrap">
        <div className="wholesale-form-card">
          <WholesaleForm />
        </div>
      </div>
    </main>
  );
}

export default Wholesale;
